export function enumKeys<
  O extends Record<string, unknown>,
  K extends keyof O = keyof O,
>(object: O): K[] {
  return Object.keys(object).filter((k) => Number.isNaN(Number(k))) as K[];
}
